import React from "react";
import { Table, Card, CardBody, CardHeader } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const RecentActivityTable = () => {
  const recentActivity = [
    {
      time: "2024-07-26 14:30",
      incidentName: "Phishing Attempt - HR Dept",
      source: "Email Gateway",
      playbookUsed: "Phishing Remediation v2.1",
      status: "Closed",
      analystAssigned: "Alice Johnson",
    },
    {
      time: "2024-07-26 13:15",
      incidentName: "Malware Detected - Server B",
      source: "EDR Agent",
      playbookUsed: "Endpoint Containment v1.5",
      status: "In Progress",
      analystAssigned: "Bob Williams",
    },
    {
      time: "2024-07-26 11:00",
      incidentName: "DDoS Attack Detected",
      source: "Cloud WAF",
      playbookUsed: "DDoS Mitigation v3.0",
      status: "Failed",
      analystAssigned: "Charlie Davis",
    },
    {
      time: "2024-07-26 10:20",
      incidentName: "Unauthorized Access - VPN",
      source: "VPN Logs",
      playbookUsed: "Access Revocation v1.0",
      status: "Closed",
      analystAssigned: "Alice Johnson",
    },
    {
      time: "2024-07-26 09:45",
      incidentName: "Data Exfiltration Alert",
      source: "DLP System",
      playbookUsed: "Data Leak Investigation v1.2",
      status: "In Progress",
      analystAssigned: "Eve Green",
    },
  ];

  const getStatusBadge = (status) => {
    if (status === "Closed") return {  color: "#29bd15ff", border: "1px solid rgba(139, 170, 67, 0.3)" };
    if (status === "In Progress") return { color: "#FF5B00", border: "1px solid rgba(251, 191, 36, 0.3)" };
    if (status === "Failed") return { color: "#d62519ff", border: "1px solid rgba(223, 51, 28, 0.3)" };
    return {  color: "#d39043", border: "1px solid rgba(206, 133, 64, 0.3)" };
  };

  return (
    <Card className="shadow-sm" style={cardShell}>
      <CardHeader>
        <h5 className="mb-0">Recent Activity</h5>
      </CardHeader>
      <CardBody>
        <div className="table-responsive">
          <Table className="table-striped table-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th>Time</th>
                <th>Incident Name</th>
                <th>Source</th>
                <th>Playbook Used</th>
                <th>Status</th>
                <th>Analyst Assigned</th>
              </tr>
            </thead>
            <tbody>
              {recentActivity.map((activity, index) => (
                <tr key={index}>
                  <td>{activity.time}</td>
                  <td>{activity.incidentName}</td>
                  <td>{activity.source}</td>
                  <td>{activity.playbookUsed}</td>
                  <td>
                    <span className="badge rounded "
                      style={getStatusBadge(activity.status)}>
                      {activity.status}
                    </span>
                  </td>
                  <td>{activity.analystAssigned}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};

export default RecentActivityTable;